<template>
  <div class="container flex flex-col items-center justify-center min-h-screen mx-auto text-center">
    <h1 class="text-5xl font-semibold">404</h1>
    <h2 class="mt-4">Page not found!</h2>
  </div>
</template>
